import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgVesselDishedEndsBrackets = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 60,
	height: 95.38,
	viewBox: "0 0 60.0 95.38",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M 50.0 7.69 L 50.0 87.69 A 13.0 5.0 0.0 0 1 10.0 87.69 L 10.0 7.69 A 13.0 5.0 0.0 0 1 50.0 7.69 Z M 10.0 7.69 L 50.0 7.69 M 10.0 87.69 L 50.0 87.69 M 50.0 62.69 L 60.0 72.69 L 50.0 72.69 Z M 10.0 62.69 L 0.0 72.69 L 10.0 72.69 Z",
		fill: "none",
		stroke: "currentColor",
		strokeWidth: 1
	})
});
export default SvgVesselDishedEndsBrackets;
